import styled from "styled-components";
import { colors } from "../../../../assets";

export const FilterContainer = styled.section`
  background-color: ${colors["detail-item-background"]};
  padding: 2em;
  display: flex;
  flex-wrap: nowrap;
  gap: 1.5em;
  width: 100%;

  .inputBox {
    width: 25%;
  }

  .selectBox {
    width: 55%;
  }

  .button-container {
    align-content: center;
  }
`;
